export default "__VITE_ASSET__439ff0e1__"